<template>
  <div>
    <banner :title="'资质荣誉'"></banner>
    <preview v-if="visable" :index="imgIndex" :imgList="honerList" @close="close"></preview>
    <div class="list">
      <div class="l-title">
        <span>
          <b>资质荣誉</b>
        </span>
      </div>
      <div class="container row" style="margin: 0 auto">
        <div
          class="col-md-4 col-6"
          style="box-sizing: border-box; margin-bottom: 20px"
          v-for="(honer, index) in honerList"
          :key="index"
        >
          <a class="lightbox" @click="preview(index)">
            <div class="item">
              <div class="pic">
                <img :src="honer.img" :alt="honer.label" />
                <i class="iconfont icon-yulan"></i>
              </div>
              <div class="txt">
                <p class="t1 ellipsis">{{ honer.label }}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../components/banner.vue";
import preview from "../components/preview.vue";
export default {
  components: {
    banner,
    preview,
  },
  data() {
    return {
      visable: false,
      imgIndex:0,
      honerList: [
        {
          img: "/honernew/20250719164701.webp",
          label: "营业执照",
        },
        // {
        //   img: "/honernew/1.webp",
        //   label: "生产许可证",
        // },
        {
          img: "/honernew/2.webp",
          label: "生产许可证",
        },
        {
          img: "/honernew/3.webp",
          label: "生产许可证",
        },
        {
          img: "/honernew/20250719170521.webp",
          label: "开户许可证",
        },
        {
          img: "/honernew/3c.webp",
          label: "3c认证",
        },
        {
          img: "/honernew/3c2.webp",
          label: "3c认证",
        },
        {
          img: "/honernew/MIA231420_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231421_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231422_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231423_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231424_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231425_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231426_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231427_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231428_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231429_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231430_01.webp",
          label: "(MA)矿用产品安全证书",
        },
        {
          img: "/honernew/MIA231482_01.webp",
          label: "(MA)矿用产品安全证书",
        },
         {
          img: "/honernew/11.webp",
          label: "质量管理体系认证证书",
        },
        {
          img: "/honernew/12.webp",
          label: "质量管理体系认证证书",
        },
        {
          img: "/honernew/15.webp",
          label: "职业健康安全管理体系认证证书",
        },
        {
          img: "/honernew/16.webp",
          label: "职业健康安全管理体系认证证书",
        },
        {
          img: "/honernew/13.webp",
          label: "环境管理体系认证证书",
        },
        {
          img: "/honernew/14.webp",
          label: "环境管理体系认证证书",
        },
       
        // {
        //   img: "/honer/honer4.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/honer5.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/honer6.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/honer7.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/honer8.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/honer9.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/honer10.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/honer11.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/honer12.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/f9ce6c6e6fc822a91920986a1e87f991_800x800.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/143c133123ebc3ae98c848baf4b4336a_800x800.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/d98fdc45869cd8a9162ef2e59719efb4_800x800.webp",
        //   label: "矿用产品安全证书",
        // },
        // {
        //   img: "/honer/9c2a802072f8a65ef7131fc7948273e7_800x800.webp",
        //   label: "欧盟证书",
        // },
        // {
        //   img: "/honer/15cdf535d84adb4578a4270eadfdf58d_800x800.webp",
        //   label: "欧盟证书",
        // },
        // {
        //   img: "/honer/eb25e313129fe06807068ff2bfd1d81d_800x800.webp",
        //   label: "欧盟证书",
        // },
        // {
        //   img: "/honer/9990be380716c08993c9fc434c8a7184_800x800.webp",
        //   label: "3c认证",
        // },
        // {
        //   img: "/honer/71a6c2732e3b46a7e5b61994b6cb05f0_800x800.webp",
        //   label: "3c认证",
        // },
        // {
        //   img: "/honer/785645e700157a1315db29c5049d63e8_800x800.webp",
        //   label: "3c认证",
        // },
        // {
        //   img: "/honer/6f2c8e9cbf7aa41d528b300f4eaa0096_800x800.webp",
        //   label: "3c认证",
        // },
        // {
        //   img: "/honer/6db55a45caf72274d6c4a7cbc97595ab_800x800.webp",
        //   label: "3c认证",
        // },
        // {
        //   img: "/honer/5b0e4a955ffd0d578750783bdebd4a20_800x800.webp",
        //   label: "3c认证",
        // },
        // {
        //   img: "/honer/3eec6e874c6f89f1db135ab3b6c87882_800x800.webp",
        //   label: "中国著名品牌",
        // },
        // {
        //   img: "/honer/748dd44156d4a6510fae10bd24d7dbe4_800x800.webp",
        //   label: "中国名优产品",
        // },
        // {
        //   img: "/honer/5fcef3fa6dbf6b9fd6d94e47ba25afef_800x800.webp",
        //   label: "中国康居示范工程首选产品",
        // },
        // {
        //   img: "/honer/9e1df38700acacb63d374037897fdaf9_800x800.webp",
        //   label: "中国工程建设重点推广产品",
        // },
        // {
        //   img: "/honer/69236c78bb5d08dec0b17fb752e9f06c_800x800.webp",
        //   label: "中国电缆行业十大品牌",
        // },
        // {
        //   img: "/honer/09347ac9ea699d19a724dcfef17ca4f9_800x800.webp",
        //   label: "政府采购推荐品牌",
        // },
        // {
        //   img: "/honer/26e4207d02f733c30d97ddc0c2586e5e_800x800.webp",
        //   label: "五星级售后服务单位",
        // },
        // {
        //   img: "/honer/e5dea3e0884b0f30c1554f23e1f58319_800x800.webp",
        //   label: "全国质量信得过单位",
        // },
        // {
        //   img: "/honer/9f8cb4c3ee20c301d4a6b78bbb444f04_800x800.webp",
        //   label: "全国质量检验稳定合格产品",
        // },
        // {
        //   img: "/honer/788e003a13e37f9e13590bc4b42014c0_800x800.webp",
        //   label: "全国政府采购十佳供应商",
        // },
        // {
        //   img: "/honer/af9791f8e16e8bb1202e579448af45e6_800x800.webp",
        //   label: "全国用户满意产品",
        // },
        // {
        //   img: "/honer/1b50f216e02d50d0e7f7b3fc246e6d84_800x800.webp",
        //   label: "全国消费者放心满意品牌",
        // },
        // {
        //   img: "/honer/ea268c87ac988af02ff21c26634a45fb_800x800.webp",
        //   label: "全国守合同重信用企业",
        // },
        // {
        //   img: "/honer/a9cf66cf4caa7cf62d340f2af9bf9f60_800x800.webp",
        //   label: "绿色环保首选品牌",
        // },
        // {
        //   img: "/honer/1536685aa1ab8562b2f18ae11b3baf5e_800x800.webp",
        //   label: "国家匠心品牌",
        // },
        // {
        //   img: "/honer/7e3ef256cc3ada5bd6763b5c86a02b77_800x800.webp",
        //   label: "国际著名品牌",
        // },
        // {
        //   img: "/honer/2df505a495f5bb36da5c80f866246550_800x800.webp",
        //   label: "国际权威检测质量达标产品",
        // },
        // {
        //   img: "/honer/f34c40339732173d58961b716c06edc3_800x800.webp",
        //   label: "国际品质、服务、诚信AAA企业",
        // },
        // {
        //   img: "/honer/e2046e8d52153a22eba105a22c9a2f91_800x800.webp",
        //   label: "管理体系认证书",
        // },
        // {
        //   img: "/honer/2818ed63273329562dd429e3bc9e7133_800x800.webp",
        //   label: "电缆行业AAA级信用企业",
        // },
        // {
        //   img: "/honer/90d4d5fbb91f2946e8307ceb320da47e_800x800.webp",
        //   label: "产品认证书",
        // },
        // {
        //   img: "/honer/48eddcdabd170b7859d2c02b8a2879da_800x800.webp",
        //   label: "315消费者信赖产品",
        // },
        // {
        //   img: "/honer/3f826272d5d3b7faa2c4bc0fcd9b9679_800x800.webp",
        //   label: "行业创新三等奖",
        // },
        // {
        //   img: "/honer/d6d4c990e1acf56fbd0fc75a879992cf_800x800.webp",
        //   label: "工业产品许可证",
        // },
        // {
        //   img: "/honer/00613511a5aa6eb728ac6455d736a700_800x800.webp",
        //   label: "电器行业协会常务理事单位",
        // },
        // {
        //   img: "/honer/e82218105b00000f514ff444322dda6f_800x800.webp",
        //   label: "电缆行业名优企业",
        // },
        // {
        //   img: "/honer/c16153dd7605fcee52411518b0047031_800x800.webp",
        //   label: "诚信口碑单位",
        // },
        // {
        //   img: "/honer/b05ca7582857ba771ff57116125c4c30_800x800.webp",
        //   label: "专利证书",
        // },
        // {
        //   img: "/honer/2cca46db26838d5169f169e515f30058_800x800.webp",
        //   label: "专利证书",
        // },
        // {
        //   img: "/honer/3ab4b6dfdd2a52d5989ae5d153631a8d_800x800.webp",
        //   label: "专利证书",
        // },
        // {
        //   img: "/honer/9ab3b5a9b67883e7ec14f52821480275_800x800.webp",
        //   label: "中原股权交易中心展示企业",
        // },
        // {
        //   img: "/honer/deefc14e022897ed9fc5c2f7aa257a46_800x800.webp",
        //   label: "国家强制性产品认证证书",
        // },
        // {
        //   img: "/honer/4a91f4a48a501690071bc0c167ef4c1c_800x800.webp",
        //   label: "诚信经营示范单位证书",
        // },
      ],
    };
  },
  methods: {
    close() {
      this.visable = false;
    },
    preview(index) {
      this.visable = true;
      this.imgIndex = index
    },
  },
};
</script>

<style lang="less" scoped>
.lightbox {
  .item {
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    overflow: hidden;
    transition: all 0.5s;
    border: solid 1px #eee;
    .pic {
      width: 100%;
      height: 250px;
      position: relative;
      overflow: hidden;
      &:after {
        width: 0;
        height: 0;
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.5s;
        border-radius: 50%;
      }
      img {
        width: 95%;
        height: 100%;
        object-fit: contain;
        position: absolute;
      }
      i {
        color: #fff;
        font-size: 50px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
        opacity: 0;
        transition: all 0.5s;
      }
    }
    .txt {
      background: #f6f5f5;
      padding: 15px;
      transition: all 0.5s;
      color: #333;
      font-size: 16px;
      font-weight: 700;
    }
    &:hover {
      box-shadow: 0 0 10px #999;
      i {
        opacity: 1;
      }
      .pic:after {
        width: 200%;
        height: 200%;
        left: -50%;
        top: -50%;
      }
      // .txt {
      //   background: @primaryColor;
      //   color: #fff;
      // }
    }
  }
}

.l-title b:after {
  content: "";
  width: 100px;
  height: 3px;
  background: @primaryColor;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 0;
}
.list .warp p {
  text-align: left;
}
</style>
